export default __webpack_public_path__ + "static/media/lookpin-logo-round.f7340058.svg";